<script lang="ts" setup>
const promptStore = usePromptStore()
</script>

<template>
  <Transition
    enter-active-class="spring-duration-150 spring-bounce-20 transform-gpu"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="spring-duration-150 spring-bounce-20 transform-gpu"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-show="promptStore.isVisible"
      class="spring-duration-150 spring-bounce-20 fixed left-0 z-40 w-full transform-gpu px-8 ease-in-out"
      :style="promptStore.hasScroll ? 'bottom: 6rem;' : 'bottom: calc(2rem + var(--footer-height));'"
    >
      <div class="flex w-full items-center justify-center">
        <div class="w-full md:w-[620px] lg:w-[720px] xl:w-[820px]">
          <Prompt class="w-full" />
        </div>
      </div>
    </div>
  </Transition>
</template>
